import React, { Fragment, useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { Dropdown } from 'util/ui'
import PresenceSettingsSidebar from '../SettingsSidebar'
import presenceTypes from '../presenceTypes'
import PresenceDropdownItem from './Item'
import PresenceDropdownSettingsItem from './SettingsItem'
import styles from './styles.less'

const buildOptions = (onClick, presence) => {
  const options = Object.values(presenceTypes).map(({ id }) => ({
    key: id,
    value: id,
    presence: id,
    onClick,
    selected: presence === id,
    as: PresenceDropdownItem,
  }))
  options.push({
    key: 'settings',
    value: 'settings',
    presence: 'settings',
    onClick,
    as: PresenceDropdownSettingsItem,
  })
  return options
}

const PresenceDropdown = ({
  onPresenceChange,
  onSettingChange,
  autoAwaySetting,
  autoOfflineSetting,
  autoPresenceSetting,
  presence,
  ...rest
}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const handleOnPresenceChange = useCallback(
    newPresence => {
      if (newPresence === 'settings') {
        setIsSidebarOpen(!isSidebarOpen)
      } else if (onPresenceChange) {
        onPresenceChange(newPresence)
      }
    },
    [onPresenceChange, isSidebarOpen, setIsSidebarOpen]
  )

  const handleOnClose = useCallback(
    () => {
      setIsSidebarOpen(false)
    },
    [setIsSidebarOpen]
  )

  const handleOnSettingChange = useCallback(
    settings => {
      setIsSidebarOpen(false)
      if (onSettingChange) onSettingChange(settings)
    },
    [setIsSidebarOpen, onSettingChange]
  )
  const options = buildOptions(
    handleOnPresenceChange,
    autoPresenceSetting ? 'autoPresence' : presence
  )

  return (
    <Fragment>
      <Dropdown
        className={styles.dropdown}
        options={options}
        icon={null}
        {...rest}
      />
      <PresenceSettingsSidebar
        open={isSidebarOpen}
        onClose={handleOnClose}
        onSave={handleOnSettingChange}
        autoAwaySetting={autoAwaySetting}
        autoOfflineSetting={autoOfflineSetting}
      />
    </Fragment>
  )
}

PresenceDropdown.propTypes = {
  /* Whether the dropdown menu is disabled */
  disabled: PropTypes.bool,

  /* Element that triggers the dropdown */
  // eslint-disable-next-line react/forbid-prop-types
  trigger: PropTypes.any,

  // Standard SUI Callbacks
  onClose: PropTypes.func,
  onBlur: PropTypes.func,

  /* onClick handler for an option (should trigger the presence change) */
  onPresenceChange: PropTypes.func,
}

PresenceDropdown.defaultProps = {
  disabled: false,
  onBlur: undefined,
  onClose: undefined,
  trigger: null,
  // eslint-disable-next-line no-console
  onPresenceChange: console.log,
}

export default PresenceDropdown
